export enum LabRequisitionStatus {
    Draft = 0,
    Completed = 1,
}